"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var _Timeline = require("./Timeline.style");

var _Icon = _interopRequireDefault(require("../Icon"));

var _class;

var Timeline = (0, _emotionTheming.withTheme)(_class =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Timeline, _React$Component);

  function Timeline() {
    (0, _classCallCheck2.default)(this, Timeline);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Timeline).apply(this, arguments));
  }

  (0, _createClass2.default)(Timeline, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          theme = _this$props.theme,
          darkMode = _this$props.darkMode;

      var children = _react.default.Children.map(this.props.children, function (child, index) {
        return _react.default.cloneElement(child, {
          theme: theme,
          index: index,
          lastIndex: index === _this.props.children.length - 1
        });
      });

      if (darkMode) {
        return _react.default.createElement(_Timeline.RootListDark, null, children);
      }

      return _react.default.createElement(_Timeline.RootList, null, children);
    }
  }]);
  return Timeline;
}(_react.default.Component)) || _class;

Timeline.checkIcon = function (theme, darkMode) {
  return _react.default.createElement(_Icon.default, {
    type: "check",
    className: (0, _classnames.default)(_Timeline.s.icon(theme, darkMode), 'check-icon')
  });
};

Timeline.user = function (image) {
  return _react.default.createElement("div", {
    className: _Timeline.s.userImage(image)
  });
};

Timeline.ActivityTimeLine = function (_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      index = _ref.index,
      lastIndex = _ref.lastIndex,
      image = _ref.image,
      title = _ref.title,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  if (!children) return null;
  return _react.default.createElement("li", {
    className: (0, _classnames.default)(_Timeline.s.item(true), className)
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)(_Timeline.s.userCircle(theme, image), 'user-circle')
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)(_Timeline.s.line(theme, index, lastIndex, true), 'line')
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)(_Timeline.s.content(true), 'content')
  }, title && _react.default.createElement("div", {
    className: (0, _classnames.default)(_Timeline.s.activityTitle(), 'title')
  }, title), children));
};

Timeline.DarkItem = function (_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme,
      index = _ref2.index,
      lastIndex = _ref2.lastIndex,
      completed = _ref2.completed,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className;
  if (!children) return null;
  return _react.default.createElement("li", {
    className: (0, _classnames.default)(_Timeline.s.item(), className)
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)(_Timeline.s.circle(theme, completed, true), 'circle')
  }, completed && Timeline.checkIcon(theme, true)), _react.default.createElement("div", {
    className: (0, _classnames.default)(_Timeline.s.darkLine(theme, index, lastIndex, completed), 'dark-line')
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)(_Timeline.s.content(false, true), 'content')
  }, children));
};

Timeline.Item = function (_ref3) {
  var children = _ref3.children,
      theme = _ref3.theme,
      index = _ref3.index,
      lastIndex = _ref3.lastIndex,
      completed = _ref3.completed;
  if (!children) return null;
  return _react.default.createElement("li", {
    className: _Timeline.s.item()
  }, _react.default.createElement("div", {
    className: _Timeline.s.circle(theme, completed, false)
  }, completed && Timeline.checkIcon(theme)), _react.default.createElement("div", {
    className: _Timeline.s.line(theme, index, lastIndex)
  }), _react.default.createElement("div", {
    className: _Timeline.s.content()
  }, children));
};

var _default = Timeline;
exports.default = _default;